import { useQueries, useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { userService } from '../../../services/UserService';
import { tenantQueryKeys } from '../tenantQueryKeys';

export function useTenantGroupMembersQuery(groupId: string | undefined) {
  const { user } = useAuth();
  const isEnabled = Boolean(user) && Boolean(groupId);

  return useQuery({
    queryKey: tenantQueryKeys.groupMembers(groupId ?? ''),
    enabled: isEnabled,
    queryFn: () => {
      if (!groupId) {
        throw new Error('groupId is required');
      }
      return userService.listGroupMembers(groupId);
    },
  });
}

export function useTenantGroupMembersQueries(
  groupIds: ReadonlyArray<string>,
  enabled = true,
) {
  const { user } = useAuth();
  const isEnabled = enabled && Boolean(user);

  return useQueries({
    queries: groupIds.map((groupId) => ({
      queryKey: tenantQueryKeys.groupMembers(groupId),
      enabled: isEnabled && groupId.length > 0,
      queryFn: () => userService.listGroupMembers(groupId),
    })),
  });
}
